var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseTuto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PAUSE",
    transform: "translate(-1610.953 -1028.54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_394",
    "data-name": "Ellipse 394",
    transform: "translate(1610.953 1028.54)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 35.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1624",
    "data-name": "Rectangle 1624",
    width: 12.055,
    height: 40.184,
    rx: 6.028,
    transform: "translate(1633.719 1045.948)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1625",
    "data-name": "Rectangle 1625",
    width: 12.055,
    height: 40.184,
    rx: 6.028,
    transform: "translate(1651.132 1045.948)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseTuto);
export default __webpack_public_path__ + "static/media/pause-tuto.80bfa15a.svg";
export { ForwardRef as ReactComponent };